export default {"src":"/_next/static/media/overlap-image-icon.56b147b7.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};